export const PRODUCTS = [
    {
      id: 1,
      name: "Red Roses",
      price: 145,
      img: 'https://images.unsplash.com/photo-1561729098-cbab0f7a9f7c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=736&q=80',
      amount: 1,
    },
    {
      id: 2,
      name: " Blue Lilies",
      price: 60,
      img: "https://images.unsplash.com/photo-1613539246066-78db6ec4ff0f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=686&q=80",
      amount: 1,
    },
    {
      id: 3,
      name: "Spring Hint",
      price: 30,
      img: "https://images.unsplash.com/photo-1583228858294-6745cb25969e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80",
      amount: 1,
    },
    {
      id: 4,
      name: "Welcoming Summer",
      price: 60,
      img: "https://images.unsplash.com/photo-1604323990536-e5452c0507c1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },
    {
      id: 5,
      name: "I appreciate you",
      price: 45,
      img: "https://images.unsplash.com/photo-1567696153798-9111f9cd3d0d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },
    {
      id: 6,
      name: "Good Morning",
      price: 20,
      img: "https://plus.unsplash.com/premium_photo-1672130977483-7cd2bb76b477?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=715&q=80",
      amount: 1,
    },
    {
      id: 7,
      name: "I miss you",
      price: 145,
      img: "https://images.unsplash.com/photo-1596438503462-50dedbfd6f1f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },
    {
      id: 8,
      name: "The way you are",
      price: 20,
      img: "https://images.unsplash.com/photo-1561181286-d3fee7d55364?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },
    {
      id: 9,
      name: "A little attention",
      price: 60,
      img: "https://plus.unsplash.com/premium_photo-1674852610103-ffdecfa8e876?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },


    {
      id: 10,
      name: "Because it's you",
      price: 45,
      img: "https://images.unsplash.com/photo-1620752379460-d4adfe02a5ce?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },
    {
      id: 11,
      name: "I wish you all the best",
      price: 60,
      img: "https://images.unsplash.com/photo-1592309487290-2cf1e17b4623?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      amount: 1,
    },
    {
      id: 12,
      name: " Say no more",
      price: 60,
      img: "https://images.unsplash.com/photo-1579783900882-c0d3dad7b119?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=708&q=80",
      amount: 1,
    },
]
export default PRODUCTS;